import { useState, useEffect } from "react";
import { Typography, Button, Modal, Box, Backdrop, Fade, Skeleton} from "@mui/material";
import { Translate, translate } from "react-i18nify";
import { PatientDetailText , PatientDetailTextInfo, PatientDetailTextWarning} from "./PatientDetailText";
import PatientDashboardCategory from "./PatientDashboardCategory";
import PatientDashboardCategoryWarning from "./PatientDashboardCategoryWarning";
import WarningIcon from '@mui/icons-material/Warning';
import EditIcon from '@mui/icons-material/Edit';
import SensorsIcon from '@mui/icons-material/Sensors';
import TimeUtils from "../../utils/TimeUtils";
import { RequireRole } from "../../utils/RequireRole";
import { PatientService } from "../../services/DataService";

export const PatientInfoComponent = (props) => {
  const [open, setOpen] = useState(false);
  
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  let patient = props.patient;
  let liveData = props.liveData;
  let locationMismatch = props.locationMismatch;
  
  return(
    <Box sx={{ height: "91%", width:"100%", mt: 1, borderRadius: "15px", border: 1, borderColor: "primary.main", bgcolor: "primary.main", color: "primary.contrastText", p: 2, display:"flex", flexDirection:"column", justifyContent: 'space-between'}}>
      
      <Box sx={{flexGrow: 1}}>
        <Typography sx={{ mt: 1 }} variant="body">
          {<Translate value="PatientInformation" />}
        </Typography>
            
        <PatientDashboardCategory // patient name
          title={patient?.patient?.name?.[0]?.given?.[0]?.value
          ? patient.patient.name[0].given[0].value + " " + patient.patient.name[0].family.value
          : "-"}
        >
        </PatientDashboardCategory>

        <Box sx={{mt: 2}}>
          <PatientDetailText // O2matic ID
            label={<Translate value="O2maticId" />}
            value={patient?.patient?.id?.value? patient?.patient?.id?.value : "-"}
          ></PatientDetailText>
          <PatientDetailText
            label={<Translate value="IdentifierType" />}
            value={patient?.patient?.identifier?.[0]?.system?.value? patient.patient.identifier[0].system.value : "-"}
          ></PatientDetailText>
          <PatientDetailText
            label={<Translate value="IdentifierValue" />}
            value={patient?.patient?.identifier?.[0]?.value?.value? patient.patient.identifier[0].value.value : "-"}
          ></PatientDetailText>
        </Box>

        <Box>
          <Box sx={{mt: 2}}>
            <PatientDetailText
              label={<Translate value="DateOfBirth" />}
              value={patient?.patient?.birthDate?.value? patient?.patient?.birthDate?.value : "-"}
            ></PatientDetailText>
            <PatientDetailText
              label={""}
              value={patient?.patient?.birthDate?.value? TimeUtils.getAge(patient?.patient?.birthDate?.value) : "-"}
              unit={patient?.patient?.birthDate?.value? translate("years") : ""}
            ></PatientDetailText>
            <PatientDetailText

              label={<Translate value="Address" />}
              value={patient?.patient?.address[0]?.line[0]?.value? patient?.patient?.address[0]?.line[0]?.value : "-"}
            ></PatientDetailText>
            <PatientDetailText
              label={<Translate value="City" />}
              value={patient?.patient?.address[0]?.city?.value? patient?.patient?.address[0]?.city?.value : "-"}
            ></PatientDetailText>
            <PatientDetailText
              label={<Translate value="PostalCode" />}
              value={patient?.patient?.address[0]?.postalCode?.value? patient?.patient?.address[0]?.postalCode?.value : "-"}
            ></PatientDetailText>
            <PatientDetailText
              label={<Translate value="Country" />}
              value={patient?.patient?.address[0]?.country?.value? patient?.patient?.address[0]?.country?.value : "-"}
            ></PatientDetailText>
          </Box>

            
          <Box sx={{mt: 2}}>
            {locationMismatch? // add warning color to location if there is a mismatch between patient location and device location
              <PatientDetailTextWarning
                label={<Translate value="Location" />}
                value={patient?.location?.name}
                explanation={<Translate value="There is a mismatch between the location of the patient and the location of the HOT device. In order for data to be received in the right location, please change locations to match." />}
              ></PatientDetailTextWarning>
              :
              <PatientDetailText
                label={<Translate value="Location" />}
                value={patient?.location?.name? patient?.location?.name : "-"}
              ></PatientDetailText>
            }
            {patient?.hasWifi == null ?
              <PatientDetailTextWarning
              label={<Translate value="Wifi" />}              
              value={translate("Unknown")}
              explanation={<Translate value="WifiUnknown" />}
            ></PatientDetailTextWarning>

            :
            <PatientDetailText
              label={<Translate value="Wifi" />}
              value={translate(patient?.hasWifi == null ? "Unknown" : patient.hasWifi ? "Yes" : "No")}
            ></PatientDetailText>
            }
          </Box>
        </Box>

      </Box>

      <Box>
        <RequireRole authorize={["PatientMonitor","PatientManager"]}>
          <Box sx={{ mt: 2, width:"100%", display:"flex", justifyContent: 'space-between'}}>
            <Box sx={{width:"55%"}}>
            <RequireRole authorize={["PatientManager"]}>
              <Button
                onClick={props.handleEdit}
                sx={{minWidth:"150px", alignSelf: "start"}}
                color="secondary"
                variant="contained"
                component="label"
                startIcon={<EditIcon/>}
                >
                  <Translate value="EditPatient" />
              </Button>
            </RequireRole>
            </Box>

            {props.showLiveDataButton ?             
              <Box sx={{width:"45%"}}>
              <RequireRole authorize={["PatientManager", "PatientMonitor"]}>           
              <Button
                onClick={props.handleLiveData}
                sx={{minWidth:"150px", alignSelf: "start", "&.Mui-disabled": {
                  background: "#eaeaea",
                  color: "#c0c0c0"
                }}}
                color="secondary"
                variant="contained"
                component="label"
                disabled={liveData?.length == 0}
                startIcon={liveData?.length == 0? <SensorsIcon sx={{color:"grey"}}/>: <SensorsIcon sx={{color:"red"}}/>}
                >
                  <Translate value="ViewLiveData" />
              </Button>
              </RequireRole>
              </Box>
            : 
              <></>
            }

          </Box>
        </RequireRole>


      </Box>

    </Box>

  )
}

export default PatientInfoComponent;
